import {isClass} from "@cm/utils"

export const recursivelyReplaceSubObjects = (obj: object, objectMapper: (obj: object) => object | void) => {
    const doReplace = (obj: object) => {
        let numReplacements = 0

        const visitedNodes = new Set<object>()
        const replaceSubObjects = (parameter: unknown): object | void => {
            if (typeof parameter !== "object" || !parameter || visitedNodes.has(parameter)) return

            const mappedObject = objectMapper(parameter)

            if (typeof mappedObject === "object") {
                visitedNodes.add(mappedObject)
                numReplacements++
                replaceSubObjects(mappedObject)
                return mappedObject
            } else if (typeof parameter === "object" && parameter) {
                visitedNodes.add(parameter)
                if (parameter instanceof Array) {
                    for (let i = 0; i < parameter.length; i++) {
                        const mappedParameter = replaceSubObjects(parameter[i])
                        if (typeof mappedParameter === "object") parameter[i] = mappedParameter
                    }
                } else if (!isClass(parameter)) {
                    for (const [key, value] of Object.entries(parameter)) {
                        const mappedParameter = replaceSubObjects(value)
                        if (typeof mappedParameter === "object") (parameter as Record<string, unknown>)[key] = mappedParameter
                    }
                }
            }
        }

        replaceSubObjects(obj)
        return numReplacements
    }

    for (let i = 0; i < 10; i++) {
        if (doReplace(obj) === 0) return
    }

    throw new Error("recursivelyReplaceSubObjects: too many iterations")
}
